import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MonHttpClientService } from '@monsido/http/http-client.service';

@NgModule({ declarations: [],
    exports: [], imports: [], providers: [MonHttpClientService, provideHttpClient(withInterceptorsFromDi())] })
export class MonHttpClientModule {}
